import OwnerModel from '../owner/owner-model';
import AppService from '../../services/app.service';
import DivisionModel from '../division/division-model';

export default class ScheduleModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    day: string;
    dayCaption: string;
    dayNo: number;
    disableDay: any;
    time: any;
    timeAll: string;
    availableDate: string;
    division: any;
    divisionCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.day = datarow.day || 'mon';
        this.dayCaption = ScheduleModel.optionDay.filter((d: any) => d.name === this.day)?.[0]?.caption|| 'Monday';
        this.dayNo = AppService.days('name').indexOf(this.day);
        this.disableDay = [0,1,2,3,4,5,6].filter((d: any) => {return d !== this.dayNo})
        this.time = datarow.time;      
        this.timeAll = this.dayCaption + ', ' + AppService.dateFormat(this.time,'h:n');
        let dayNo =new Date().getDay();
        let addDays = (dayNo >= this.dayNo? 7 : this.dayNo) - dayNo + this.dayNo;
        this.availableDate = AppService.dateISO('', AppService.dateFormat(this.time, 'h:n:s'), addDays);
        let division = datarow.division?.data? new DivisionModel(datarow.division?.data) : datarow.division;
        this.division = division?.id;
        this.divisionCaption = division?.name;
    }

    public static endPoint: string = 'schedules' 
    public static endPointFilterList = (productId?: number) => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner + (productId? '&filters[product]=' +productId : ''));
    } 
    public static url: string = '/schedule';
    public static caption: string = 'Schedule';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(), 
        day: 'mon',
        dayCaption: 'Monday',
        dayNo: 1,
        disableDay: [],
        time: null,
        timeAll: '',
        availableDate : AppService.dateCurrent(),
        division: null,
        divisionCaption: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static columnPicklistCard = [
        { name: 'name', type: 'caption' },
        { name: 'description' },
        { name: 'dayCaption', type: 'state', default: 'Monday' },
        { name: 'time', type: 'time2' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionDay = AppService.optionDay;
}